import React from 'react';

import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import IconButton from '@atlaskit/button/icon/button';

import { usePageState } from '@confluence/page-context';
import { getUrlForContentType } from '@confluence/content-types-utils/entry-points/getUrlForContentType.ts';

export const LoomExternalOpenButton: React.FC = () => {
	const [{ contentId, contentType, spaceKey }] = usePageState();

	const handleClick = () => {
		if (!contentId || !contentType || !spaceKey) {
			return;
		}

		const url = getUrlForContentType({ contentType, contentId, spaceKey, redirectToEditor: false });
		if (!url) {
			return;
		}

		window.open(url, '_blank');
	};

	return (
		<IconButton
			icon={LinkExternalIcon}
			label="Open in new window"
			onClick={handleClick}
			testId="loom-external-open-button"
		/>
	);
};
